import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import '../../css/base.css';
import InjectedCheckoutForm from './injectedCheckoutForm';
import scenery5_large from '../../img/scenery5_large.jpg';

//const stripePromise = loadStripe("pk_test_51LWFALJulOPb6gIJQGiEAbLDWSzw5vopazVsrGfA2pB5kduBEv4U7nlzyocQOe8e59WxBwp0TY2fVDT0Dyjp83Kl00WvZlhPuh");
const stripePromise = loadStripe("pk_live_51LWFALJulOPb6gIJkuS1XZQH0W5nPCn9pmVTRzWJmexO6jzOk7gLKerJDYpNQafFZXXCVVMtSdWW8KlPlslydIZe00zYAzWD49");

const CheckoutComposite = () => {

  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    window.scrollTo(0,0);

  }, []);

  const {  clientSecret } = appstate;

  const appearance = {
    theme: 'stripe',
  };
  
  const options = {
    clientSecret: clientSecret,
    appearance,
  };


  return (
      <div>
        { clientSecret ? (
          <Elements options={options} stripe={stripePromise}>
            <InjectedCheckoutForm />
          </Elements>
        ) : 
        (<div>
          <div className="row">
            <div className="col-12 col-md-6 imagesBackgroundColour"> 
            </div>
            <div className="col-12 col-md-6 imagesBackgroundColour"> 
              <img src={scenery5_large} alt="Welcome Door" className="gallery-image" />
            </div>
          </div>
          <div className="loader" id="loader" />
        </div>) }
      </div>
  );
}

export default CheckoutComposite

